import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';

import Header from '../../Typography/Header';
import PostOrder from '../../ListItems/PostOrder';
import PostOrderDialog from '../../Dialogs/AddPostOrder';


const PostOrders = ({ isEditable, timezone }) => {
  const [showPostOrderDialog, setShowPostOrderDialog] = useState(false);

  const postOrders = useSelector(state => state.postOrders.postOrders);

  return (
    <>
      <Header 
        label={'Post orders'} 
        action={isEditable && { title: 'Add', onClick: () => setShowPostOrderDialog(true)}} 
      />
      {
        postOrders.length > 0 ? (
          postOrders.map(
            (postOrder, index) => <PostOrder 
              key={index}
              postOrder={postOrder} 
              isEditable={isEditable}
              timezone={timezone} 
              index={index}
            />
          )
        ) : (
          <Typography>No post orders added.</Typography>
        )
      }
      <PostOrderDialog 
        isOpen={showPostOrderDialog} 
        onClose={() => setShowPostOrderDialog(false)} 
        timezone={timezone}
      />
    </>
  )
};

export default PostOrders;